<template>
  <a-config-provider :locale="locale">
    <a-spin class="spin-wrap" :spinning="spinning || backLoading" tip="Loading...">
      <a-icon slot="indicator" type="loading" style="font-size: 24px"/>
      <div id="app" ref="app">
        <router-view/>

        <div class="qcode" title="Back to the top">
          <img src="@/assets/goTop.png" alt class="gotop" @click="gotop" v-if="showTop">
        </div>
      </div>
      <a-modal
        :visible="visible"
        @cancel="
          () => {
            visible = false
          }
        "
        :footer="null"
        width="980px"
        title="待办提醒"
        wrapClassName="imgModal"
        :getContainer="() => document.getElementById('app')"
      >
        <div class="modal-body">
          <div class="reminder-wrap">
            <h5>您有以下待处理事项，请尽快处理!</h5>
            <div class="reminderBody">
              <template v-if="getException.exception && Object.keys(getException.exception).length">
                <div
                  class="reminderItem"
                  v-for="(item, i) in getException.exception"
                  :key="`exception-${i}`"
                >
                  <span>
                    <b>{{ item }}</b>个
                    <template v-if="+i === 100">wish邮授权已过期</template>
                    <template v-else>{{ platformName[i].name || '' }}店铺授权已过期</template>
                  </span>
                  <span>
                    <a @click="toSearch(i)">立即处理</a>
                  </span>
                </div>
              </template>
              <template v-if="getException.recently1 && Object.keys(getException.recently1).length">
                <div
                  class="reminderItem"
                  v-for="(item, i) in getException.recently1"
                  :key="`recently1-${i}`"
                >
                  <span>
                    <b>{{ item }}</b>个
                    <template v-if="+i === 100">wish邮授权还剩一天即将到期</template>
                    <template v-else>{{ platformName[i].name || '' }}店铺授权还剩一天即将到期</template>
                  </span>
                  <span>
                    <a @click="toSearch(i)">立即处理</a>
                  </span>
                </div>
              </template>
              <template v-if="getException.recently7 && Object.keys(getException.recently7).length">
                <div
                  class="reminderItem"
                  v-for="(item, i) in getException.recently7"
                  :key="`recently1-${i}`"
                >
                  <span>
                    <b>{{ item }}</b>个
                    <template v-if="+i === 100">wish邮授权还剩七天即将到期</template>
                    <template v-else>{{ platformName[i].name || '' }}店铺授权还剩七天即将到期</template>
                  </span>
                  <span>
                    <a @click="toSearch(i)">立即处理</a>
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="footer-btn">
          <span>
            <!-- <a-checkbox :checked="isBlack" @change="isBlackFn">
              七天内不再提醒
            </a-checkbox>-->
          </span>
          <span>
            <a-button @click="visibleFn">关闭</a-button>
          </span>
        </div>
      </a-modal>
      <a-modal
        :visible="toPCVisible"
        @cancel="
          () => {
            toPCVisible = false
          }
        "
        :footer="null"
        wrapClassName="to-pc-modal"
        :getContainer="() => document.getElementById('app')"
      >
        <div class="modal-wrap">
          <h2>PrintDoors looks best on desktop</h2>
          <p>Please use PC browser to complete the process for a better experience.</p>
          <img src="@/assets/1.mobile.forbiden.png" alt style="width: 70%;">
          <div class="footer-wrap">
            <h1>Visit our site on PC browser.(Chrome Rec.)</h1>
            <div class="tip-item">
              <div class="dot"></div>
              <span>Better user experience;</span>
            </div>
            <div class="tip-item">
              <div class="dot"></div>
              <span>Easy integration services;</span>
            </div>
            <div class="tip-item">
              <div class="dot"></div>
              <span>Enjoy more discounts</span>
            </div>
            <div class="tip-item">
              <div class="dot"></div>
              <span>More complete designer functions;</span>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal
        title="Notice"
        :visible="systemNoticeVisible"
        @cancel="
          () => {
            systemNoticeVisible = false
          }
        "
        width="1000px"
        :footer="null"
        :getContainer="() => document.getElementById('app')"
      >
        <div class="notice_detail">
          <div
            class="title"
          >{{ detailData.title || 'Introducing Exciting Brand Value-Added Services on PrintDoors' }}</div>
          <div class="created_time">{{ detailData.created_at }}</div>
          <div class="autoWrap">
            <div v-html="detailData.desc" class="desc ql-editor"></div>
          </div>
        </div>
        <a-button @click="goDetail(detailData.id)" type="primary" style="margin-left: 40%">View more</a-button>
      </a-modal>
      <a-modal
        title="Warning message"
        :visible="warningMessageVisible"
        @cancel="
          () => {
            warningMessageVisible = false
          }
        "
        width="1000px"
        :footer="null"
        :getContainer="() => document.getElementById('app')"
      >
        <div>
          <div
            style="font-size: 18px;color: #000; line-height: 32px;"
            v-html="userInfo.warning_message"
          ></div>
        </div>
        <div style="margin-top: 20px; text-align: center;">
          <a-button @click="warningMessageVisible = false" type="primary">Close{{ coustNum }}</a-button>
        </div>
      </a-modal>
      <a-modal
        :visible="couponVisible"
        @cancel="
          () => {
            couponVisible = false
          }
        "
        centered
        zIndex="1100"
        width="800px"
        :footer="null"
        :getContainer="() => document.getElementById('app')"
      >
        <div slot="title" style="font-size: 22px; line-height: 32px;">
          After platform review，you have obtained three large coupons，which have been automatically issued to your account.
          <a
            href="/personal_center/coupon"
          >Please check</a>.
        </div>
        <div class="couponWrap">
          <img src="@/assets/coupon/coupon.png">
        </div>
      </a-modal>
    </a-spin>
  </a-config-provider>
</template>

<script>
// import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/es/locale/en_US'
import { AppDeviceEnquire } from '@/utils/mixin'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { platformName } from '@/utils/const'
import { getCouponReminder, putCouponReminder } from '@/api/coupon'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { getSystemNoticeDetail } from '@/api/systemNotice'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  mixins: [AppDeviceEnquire],
  data() {
    return {
      couponVisible: false,
      isBlack: false,
      visible: false,
      platformName: platformName,
      locale: enUS,
      showTop: false,
      toPCVisible: false,
      systemNoticeVisible: false,
      warningMessageVisible: false,
      detailData: {},
      lastCouponFetchDate: '' // 记录上次获取优惠券的日期
    }
  },

  // ==================== 全局 GA4 点击埋点（已插入）====================
  mounted() {
    this.initGlobalGA4Click()

    if (this.userInfo) {
      if (this.userInfo.id) {
        // 获取临时优惠卷（已添加每日限制）
        this.getCouponReminderFn()
      }
      if (this.userInfo.warning_message) {
        this.warningMessageVisible = true
      }
    }
    this.initLoader()
    window.onscroll = this.getPageScroll
    // window.innerWidth < 960 && (window.__ssc.setting = { hideIcon: true })
  },

  methods: {
    ...mapMutations({
      setThreeLoader: 'SET_THREE_LOADER',
      setException: 'SET_EXCEPTION'
    }),

    // 全局 GA4 自动点击埋点（全站所有页面生效）
    initGlobalGA4Click() {
      if (!window.gtag) {
        console.log('⚠️ GA4 未加载，跳过全局埋点')
        return
      }

      document.addEventListener('click', (e) => {
        const target = e.target
        if (!target) return

        const text = (target.innerText || '').trim().slice(0, 30)
        const className = target.className || ''
        const tagName = target.tagName || ''
        const href = target.href || target.closest('a')?.href || ''
        const path = window.location.pathname

        let module = 'unknown'
        if (className.includes('header') || className.includes('nav') || tagName === 'A-MENU-ITEM') {
          module = 'nav'
        } else if (className.includes('banner')) {
          module = 'banner'
        } else if (className.includes('footer')) {
          module = 'footer'
        } else if (className.includes('logo')) {
          module = 'nav'
        } else if (className.includes('user') || className.includes('cart')) {
          module = 'user'
        } else if (className.includes('product')) {
          module = 'product'
        } else if (path.includes('/products')) {
          module = 'product_list'
        } else if (path === '/home') {
          module = 'home'
        } else {
          module = 'other'
        }

        let element = 'click'
        if (text) {
          element = text.replace(/\s+/g, '_').replace(/[^\w]/g, '').toLowerCase()
        } else if (href) {
          element = href.split('/').filter(Boolean).pop() || 'link'
        } else if (className) {
          element = className.split(' ')[0]
        }
        element = element.slice(0, 40)

        // 上报 GA4
        window.gtag('event', 'page_click', {
          page_path: path,
          module: module,
          element: element,
          action: 'click'
        })

        console.log('✅ GA4 全局上报：', {
          page: path,
          module: module,
          element: element
        })
      })
    },

    // 获取临时优惠券（每日限制调用一次）
    getCouponReminderFn() {
      const today = new Date().toISOString().split('T')[0]

      // 从 localStorage 获取上次调用日期
      const lastFetchDate = this.$ls.get('lastCouponFetchDate')

      // 如果今天已经调用过，则直接返回
      if (lastFetchDate === today) {
        console.log('今天已经获取过临时优惠券，跳过调用')
        return
      }

      // 调用接口
      getCouponReminder({}).then(res => {
        if (res.data && res.data.length && res.data[0].is_read === 0) {
          this.couponVisible = true
          putCouponReminder(res.data[0].id).then(data => {
            console.log('成功!')
          })
        }
        // 无论是否有优惠券，都记录调用日期
        this.$ls.set('lastCouponFetchDate', today)
      }).catch(err => {
        console.error('获取优惠券失败:', err)
        // 接口调用失败时不记录日期，允许下次重试
      })
    },

    // 强制获取临时优惠券（用于特殊情况，如手动刷新）
    forceGetCouponReminder() {
      // 清除日期记录，强制重新调用
      this.$ls.remove('lastCouponFetchDate')
      this.getCouponReminderFn()
    },

    initLoader() {
      const loader = new GLTFLoader()
      const dracoLoader = new DRACOLoader()
      dracoLoader.setDecoderPath('/draco/gltf/')
      loader.setDRACOLoader(dracoLoader)
      this.setThreeLoader(loader)
    },
    saveToken() {
      window.addEventListener(
        'message',
        e => {
          const { data } = e
          console.log(1234555, data)
          if (data.token) {
            this.$ls.set('Access-Token', data.token, 7 * 24 * 60 * 60 * 1000)
          }
        },
        false
      )
    },
    gotop() {
      window.scrollTo(0, 0)
    },
    getPageScroll() {
      const top = document.body.scrollTop || document.documentElement.scrollTop
      const { height } = document.body.getBoundingClientRect()
      if (top > height) {
        this.showTop = true
      } else {
        this.showTop = false
      }
    },
    visibleFn() {
      if (this.isBlack) {
        const date = new Date()
        const time = date.getTime()
        this.$ls.set('storeConfirmTime', time)
      } else {
        this.$ls.set('storeConfirmTime', 0)
      }
      this.visible = false
    },
    isBlackFn() {
      this.isBlack = !this.isBlack
    },
    toSearch(id) {
      this.visible = false
      this.$router.push(`/myOrder/storeAdmin?platform=${id}&authStatus=1`)
    },
    goDetail(id) {
      console.log(id)
      this.systemNoticeVisible = false
      this.$router.push('/systemnotice/' + id)
    }
  },
  computed: {
    ...mapGetters(['getToken', 'getException']),
    ...mapState({
      spinning: state => state.app.loading,
      backLoading: state => state.app.backLoading,
      systemNoticePolling: state => state.user.systemNoticePolling,
      userInfo: state => state.user.info
    })
  },
  watch: {
    $route(route) {
      ;(route.name === 'main' || route.name === 'home') && window.innerWidth < 960 && (this.toPCVisible = true)
      if (this.systemNoticePolling.alter_notice_id && this.systemNoticePolling.alter_notice_is_read === 2) {
        getSystemNoticeDetail(this.systemNoticePolling.alter_notice_id).then(res => {
          this.detailData = res.data
          this.systemNoticeVisible = true
        })
      }
    },
    toPCVisible(value) {
      value && (this.$refs.app.style.overflow = 'hidden')
      !value && (this.$refs.app.style.overflow = 'auto')
    },
    userInfo(value) {
      if (value && value.id) {
        // 获取临时优惠卷（已添加每日限制）
        console.log('userInfo===2222', value.id)
        this.getCouponReminderFn()
      }
      if (value && value.warning_message) {
        this.warningMessageVisible = true
      }
    }
  },
  created() {
    // this.$ls.set('RECOMMENDED_SOURCES', document.referrer)
    if (
      document.referrer.indexOf('https://www.printdoors.com/') === -1 &&
      document.referrer.indexOf('https://accounts.google.com/') === -1
    ) {
      this.$ls.set('RECOMMENDED_SOURCES', document.referrer)
    }

    // 如果创建时已有用户信息，也检查优惠券（会经过每日限制判断）
    if (this.userInfo && this.userInfo.id) {
      this.getCouponReminderFn()
    }
  }
}
</script>
<style lang="less" scoped>
body {
  background: #f0f0f0;
}
#app {
  min-width: 1400px;
  margin: 0 auto;
  .qcode {
    position: fixed;
    bottom: 150px;
    right: 20px;
    cursor: pointer;
    z-index: 99;
    img {
      width: 50px;
    }
  }
  /deep/.ant-modal-root {
    .modal-wrap {
      position: relative;
      text-align: center;
      > h1 {
        font-size: 24px;
        color: #333333;
      }
      > p {
        font-size: 14px;
        color: #666666;
      }
      .footer-wrap {
        position: absolute;
        left: 50%;
        top: 110%;
        transform: translate(-50%, 0);
        width: 100%;
        border-radius: 8px 8px 8px 8px;
        padding: 16px;
        background: linear-gradient(180deg, #ffb800 0%, #ff6f00 100%);
        > h1 {
          font-size: 14px;
          color: white;
        }
        > .tip-item {
          padding: 0 0 0 20px;
          display: flex;
          line-height: 32px;
          align-items: center;
          background: rgba(255, 255, 255, 0.3);
          height: 32px;
          margin-top: 20px;
          border-radius: 8px 8px 8px 8px;
          color: white;
          > .dot {
            margin-right: 12px;
            height: 6px;
            width: 6px;
            border-radius: 6px;
            background: #ff7800;
          }
        }
      }
    }
  }
}
.notice_detail {
  .title {
    font-size: 20px;
    font-weight: 700;
    color: #333;
  }
  .created_time {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 20px;
  }
}
.autoWrap {
  max-height: 420px;
  overflow-y: auto;
  margin-bottom: 20px;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
    background: rgba(6, 6, 13, 0.2);
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: #eee;
  }
}
@media screen and (max-width: 960px) {
  #app {
    min-width: 100%;
    margin: 0 auto;
  }
}
.reminder-wrap {
  padding: 0 20px;
  h5 {
    font-size: 16px;
    color: #333;
  }
  .reminderBody {
    padding: 0 60px 0 60px;
    .reminderItem {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      height: 30px;
      margin: 4px 0;
      font-size: 16px;
      color: #333;
      b {
        color: #ff0000;
      }
    }
  }
}
.footer-btn {
  margin-top: 20px;
  padding: 16px 20px 8px 20px;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-top: 1px solid #ddd;
}
.couponWrap {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  .couponItem {
    margin: 20px 12px 0 12px;
    width: 357px;
    height: 170px;
    border-radius: 5px;
    box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.3);
    background: url('./assets/coupon/coupon_background.png') center top no-repeat;
  }
}
</style>
<style>
.desc img {
  max-width: 100%;
  object-fit: fill;
}
</style>
